export type EnvBannerVariant = 'uat' | 'dev' | null;

export function getEnvBannerVariant(): EnvBannerVariant {
  const raw = process.env.NEXT_PUBLIC_DEPLOY_ENV || '';
  const value = raw.trim().toLowerCase();

  if (value === 'uat') {
    return 'uat';
  }

  return null;
}
